import type { BoxProps, PaperProps } from '@mui/material';
import { Tab, Tabs, Typography, Box, Paper, styled } from '@mui/material';
import Color from 'color';

export const WidgetWrapper = styled((props: PaperProps) => (
  <Paper elevation={3} {...props} />
))(({ theme }) => {
  return {
    padding: '1.5rem',
    marginBottom: '1.5rem',
    marginTop: '1rem',
    color: theme.palette.text.contrastText,
    border:
      theme.palette.mode === 'light'
        ? 'none'
        : `1.75px solid ${theme.palette.divider}`,
  };
});

export const InfoCard = styled(Box)(({ theme }) => {
  return {
    background:
      theme.palette.mode === 'light'
        ? Color(theme.palette.background.active).lighten(0.05).toString()
        : Color(theme.palette.background.active).darken(0.2).toString(),
    borderRadius: 5,
    padding: '1rem',
  };
});

export const WidgetTitle = styled(Typography)(() => {
  return {
    fontSize: '1.5rem',
    fontWeight: 600,
  };
});

/* Tabs */
interface StyledTabsProps {
  children?: React.ReactNode;
  value: number | string;
  onChange: (event: React.SyntheticEvent, newValue: any) => void;
}

export const StyledTabs = styled((props: StyledTabsProps) => (
  <Tabs
    {...props}
    TabIndicatorProps={{
      children: <span className="MuiTabs-indicatorSpan" />,
    }}
  />
))(({ theme }) => {
  return {
    marginTop: '-1rem',
    marginBottom: '1rem',
    '& .MuiTabs-indicator': {
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: 'transparent',
    },
    '& .MuiTabs-indicatorSpan': {
      width: '100%',
      backgroundColor:
        theme.palette.mode === 'dark'
          ? theme.config.colors.cowbellBlue
          : Color(theme.config.colors.cowbellBlue).lighten(0.15).toString(),
    },
  };
});

interface StyledTabProps {
  label: string;
  value?: string;
}

export const StyledTab = styled((props: StyledTabProps) => (
  <Tab disableRipple {...props} />
))(({ theme }) => ({
  fontSize: '1.2rem',
  letterSpacing: 0.99,
  marginRight: '0.35rem',
  color:
    theme.palette.mode === 'dark'
      ? 'rgba(255, 255, 255, 0.7)'
      : 'rgba(0, 0, 0, 0.7)',
  padding: '0.5rem',
  paddingBottom: 0,
  '&.Mui-selected': {
    color: theme.palette.mode === 'dark' ? '#fff' : '#000',
  },
  '&.Mui-focusVisible': {
    backgroundColor: theme.config.colors.cowbellBlue,
  },
}));

export const ViewContainer = styled((props: BoxProps) => (
  <Box px={2} component="section" {...props} />
))(() => {
  return {
    marginTop: '-1rem',
  };
});
